import { IAbhyasaBharathiFileFilter } from "../models/abhyasaBharathi";

export const AbhyasaBharathiFilters: IAbhyasaBharathiFileFilter[] = [
    {
        filterId: 1,
        filterName: "July - Aug"
    },
    {
        filterId: 2,
        filterName: "Sep - Oct"
    },
    {
        filterId: 3,
        filterName: "Nov - Dec"
    },
    {
        filterId: 4,
        filterName: "Jan - Feb"
    },
    {
        filterId: 5,
        filterName: "Mar - Apr"
    }
]